/**
 * Takes a Date object as an input and returns a new Date object with the offset
 * of the EST equivalent date/time
 *
 * @param date Date
 * @returns date
 */
const offsetDateToEst = (date) => {
    const est = new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const offset = date.getTime() - est.getTime();
    return new Date(date.getTime() - offset);
};
export default offsetDateToEst;
